module.exports = __webpack_public_path__ + "static/img/photo-ocean-01.f4bc01a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-ocean-01.jpg
// module id = VbQd
// module chunks = 1